"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clock_1 = require("@almservices-cl/clock");
const Iterator_1 = __importDefault(require("./Iterator"));
class SportActivityMock {
    constructor() {
        this.fetchSportActivities = (_userId, dateRange) => {
            const dates = (0, clock_1.getDatesOfDateRange)(dateRange);
            const idIterator = new Iterator_1.default([
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
            ]);
            const durationIterator = new Iterator_1.default([3, 10, 5, 21, 34]);
            const isCustomIterator = new Iterator_1.default([false, false, true]);
            const items = dates.map((date) => {
                return {
                    date,
                    sportActivities: [
                        {
                            id: idIterator.next(),
                            date,
                            exertion: 4,
                            duration: durationIterator.next(),
                            note: "test note",
                            type: {
                                isCustom: isCustomIterator.next(),
                                name: "walk",
                                iconUrl: "svgUrl",
                            },
                        },
                    ],
                };
            });
            return Promise.resolve(items);
        };
    }
    fetchSportActivitiesPerDate(_userId, dateRange) {
        const dates = (0, clock_1.getDatesOfDateRange)(dateRange);
        const activitiesPerDateIterator = new Iterator_1.default([2, 0, 1, 1, 3]);
        const activitiesPerDate = dates.map((date) => ({
            date,
            activitiesInDay: activitiesPerDateIterator.next(),
        }));
        return Promise.resolve({ sportActivitiesPerDate: activitiesPerDate });
    }
}
exports.default = SportActivityMock;
//# sourceMappingURL=SportActivityMock.js.map